import { qs, qsAll } from "scripts/data_utils/domHelpers";
import { getPositionToScrollToElement } from "scripts/utils/scroll";

async function expandSectionContent(e) {
  const {
    target
  } = e;
  const parent = target.closest(".js-section");
  const content = qs(".js-section-content", parent);
  const isOpen = parent.classList.contains("is-open");

  if (content) {
    content.style.height = isOpen ? 0 : `${content.scrollHeight}px`;
  }

  parent.classList[isOpen ? "remove" : "add"]("is-open");
}

document.addEventListener("DOMContentLoaded", () => {
  qsAll(".js-section-header").map(header => header.addEventListener("click", expandSectionContent));
  const {
    hash
  } = window.location;

  if (hash) {
    const section = qs(hash);

    if (section) {
      const top = getPositionToScrollToElement(section);
      window.scroll({
        top,
        left: 0,
        behavior: "smooth"
      });

      if (hash) {
        const sectionHeader = qs(".js-section-header", section);

        if (sectionHeader) {
          sectionHeader.click();
        }
      }
    }
  }

  const toUpButton = qs(".js-to-up-button");

  function checkScroll() {
    if (!toUpButton) {
      return;
    }

    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    toUpButton.classList[scrolled > 300 ? "add" : "remove"]("to-up-button--showed");
  }

  if (toUpButton) {
    window.addEventListener("scroll", checkScroll);
    toUpButton.addEventListener("click", () => window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    }));
    checkScroll();
  }

  qsAll(".js-copy-link").map(link => {
    link.addEventListener("click", () => {
      const {
        id
      } = link.closest(".js-section");
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.value = `${window.location.origin}${window.location.pathname}#${id}`;
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
    });
  });
});